module.exports = __webpack_public_path__ + "src/assets/img/engine_one.7c378049.svg";